import { ReactElement } from 'react';
import ActionPlaceholder from './utils/actionPlaceholder';

interface Props {
  Download?: ReactElement | false;
  Retry?: ReactElement | false;
  Details?: ReactElement | false;
  Delete?: ReactElement | false;
  Cancel?: ReactElement | false;
}

const Actions = ({ Download, Retry, Details, Delete, Cancel }: Props) => {
  if (Delete && Cancel) {
    throw new Error('You cannot declare these actions together');
  }
  const firstRow = Download || Retry || <ActionPlaceholder />;
  const secondRow = Details || <ActionPlaceholder />;
  const thirdRow = Delete || Cancel || <ActionPlaceholder />;
  return (
    <>
      {firstRow}
      {secondRow}
      {thirdRow}
    </>
  );
};

export default Actions;
